import React, { Component } from "react";
import {
  DatePicker,
  Select,
  Radio,
  Space,
  Checkbox,
  message,
  Spin,
  Input,
} from "antd";
import Bridge from "../../../../utils/Bridge";
import { RESEARCH_TYPE } from "../../../../utils/consts";
import dayjs from "dayjs";
import moment from "moment";
const { TextArea } = Input;

const { Option } = Select;

export default class MedicalHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,

      neurological_disease: "",
      stroke: "",
      traumatic_brain_injury: "",
      respiratory_disease: "",
      bipolar_disorder: "",
      brain_aneurysm: "",
      cancer: "",
      depression: "",
      diabetes: "",
      epilepsy: "",
      muscle_disease: "",
      schizophrenia: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Neurological Disease") {
                this.setState({
                  neurological_disease: item.value,
                });
              }
              if (item.field == "Stroke") {
                this.setState({
                  stroke: item.value,
                });
              }
              if (item.field == "Traumatic Brain Injury") {
                this.setState({
                  traumatic_brain_injury: item.value,
                });
              }
              if (item.field == "Respiratory Disease") {
                this.setState({
                  respiratory_disease: item.value,
                });
              }
              if (item.field == "Bipolar Disorder") {
                this.setState({
                  bipolar_disorder: item.value,
                });
              }
              if (item.field == "Brain Aneurysm") {
                this.setState({
                  brain_aneurysm: item.value,
                });
              }
              if (item.field == "Cancer") {
                this.setState({
                  cancer: item.value,
                });
              }
              if (item.field == "Depression") {
                this.setState({
                  depression: item.value,
                });
              }
              if (item.field == "Diabetes") {
                this.setState({
                  diabetes: item.value,
                });
              }
              if (item.field == "Epilepsy") {
                this.setState({
                  epilepsy: item.value,
                });
              }
              if (item.field == "Muscle Disease") {
                this.setState({
                  muscle_disease: item.value,
                });
              }
              if (item.field == "Schizophrenia") {
                this.setState({
                  schizophrenia: item.value,
                });
              }
            }
          }
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  save = () => {
    if (!this.state.neurological_disease) {
      message.warning("Please choose 'Neurological Disease' field");
      return;
    }
    if (!this.state.stroke) {
      message.warning("Please choose 'Stroke' field");
      return;
    }
    if (!this.state.traumatic_brain_injury) {
      message.warning("Please choose 'Traumatic Brain Injury' field");
      return;
    }
    if (!this.state.respiratory_disease) {
      message.warning("Please choose 'Respiratory Disease' field");
      return;
    }
    if (!this.state.bipolar_disorder) {
      message.warning("Please choose 'Bipolar Disorder' field");
      return;
    }
    if (!this.state.brain_aneurysm) {
      message.warning("Please choose 'Brain Aneurysm' field");
      return;
    }
    if (!this.state.cancer) {
      message.warning("Please choose 'Cancer' field");
      return;
    }
    if (!this.state.depression) {
      message.warning("Please choose 'Depression' field");
      return;
    }
    if (!this.state.diabetes) {
      message.warning("Please choose 'Diabetes' field");
      return;
    }
    if (!this.state.epilepsy) {
      message.warning("Please choose 'Epilepsy' field");
      return;
    }
    if (!this.state.muscle_disease) {
      message.warning("Please choose 'Muscle Disease' field");
      return;
    }
    if (!this.state.schizophrenia) {
      message.warning("Please choose 'Schizophrenia' field");
      return;
    }
    let questions = [
      {
        parent_field: "Neurological Disease",
        field: "Neurological Disease",
        value: this.state.neurological_disease,
      },
      {
        parent_field: "Stroke",
        field: "Stroke",
        value: this.state.stroke,
      },
      {
        parent_field: "Traumatic Brain Injury",
        field: "Traumatic Brain Injury",
        value: this.state.traumatic_brain_injury,
      },
      {
        parent_field: "Respiratory Disease",
        field: "Respiratory Disease",
        value: this.state.respiratory_disease,
      },
      {
        parent_field: "Bipolar Disorder",
        field: "Bipolar Disorder",
        value: this.state.bipolar_disorder,
      },
      {
        parent_field: "Brain Aneurysm",
        field: "Brain Aneurysm",
        value: this.state.brain_aneurysm,
      },
      {
        parent_field: "Cancer",
        field: "Cancer",
        value: this.state.cancer,
      },
      {
        parent_field: "Depression",
        field: "Depression",
        value: this.state.depression,
      },
      {
        parent_field: "Diabetes",
        field: "Diabetes",
        value: this.state.diabetes,
      },
      {
        parent_field: "Epilepsy",
        field: "Epilepsy",
        value: this.state.epilepsy,
      },
      {
        parent_field: "Muscle Disease",
        field: "Muscle Disease",
        value: this.state.muscle_disease,
      },
      {
        parent_field: "Schizophrenia",
        field: "Schizophrenia",
        value: this.state.schizophrenia,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "5",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                setTimeout(() => {
                  window.location.assign("/dashboard");
                }, 3000);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  onHandleChangeFollowingHistory = (e) => {
    let value = e.target.value;
    let tempArr = this.state.any_history_of_the_following;
    if (tempArr.includes(value)) {
      let newArray = [];
      for (let item of tempArr) {
        if (item != value) {
          newArray.push(item);
        }
      }
      this.setState({ any_history_of_the_following: newArray });
    } else {
      tempArr.push(value);
      this.setState({ any_history_of_the_following: tempArr });
    }
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment();
    };
    return (
      <div>
        <div className="header">
          <h3>MEDICAL HISTORY</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                Do you have a history of any of the following? &nbsp;
                <i style={{ fontWeight: "400" }}>
                  (select all that apply)
                </i>{" "}
                <span className="text-danger">*</span>
              </label>
              <div>
                <div className="pl-0 col-lg-7">
                  <div className="form-group">
                    <label className="input-heading">
                      Neurological Disease{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          neurological_disease: e.target.value,
                        })
                      }
                      value={this.state.neurological_disease}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Stroke <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          stroke: e.target.value,
                        })
                      }
                      value={this.state.stroke}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Traumatic Brain Injury{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          traumatic_brain_injury: e.target.value,
                        })
                      }
                      value={this.state.traumatic_brain_injury}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Respiratory Disease <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          respiratory_disease: e.target.value,
                        })
                      }
                      value={this.state.respiratory_disease}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Bipolar Disorder <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          bipolar_disorder: e.target.value,
                        })
                      }
                      value={this.state.bipolar_disorder}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Brain Aneurysm <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          brain_aneurysm: e.target.value,
                        })
                      }
                      value={this.state.brain_aneurysm}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Cancer <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          cancer: e.target.value,
                        })
                      }
                      value={this.state.cancer}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Depression <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          depression: e.target.value,
                        })
                      }
                      value={this.state.depression}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Diabetes <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          diabetes: e.target.value,
                        })
                      }
                      value={this.state.diabetes}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Epilepsy <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          epilepsy: e.target.value,
                        })
                      }
                      value={this.state.epilepsy}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      {" "}
                      Muscle Disease <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          muscle_disease: e.target.value,
                        })
                      }
                      value={this.state.muscle_disease}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <div className="form-group">
                    <label className="input-heading">
                      Schizophrenia <span className="text-danger">*</span>
                    </label>
                    <br />
                    <Radio.Group
                      onChange={(e) =>
                        this.setState({
                          schizophrenia: e.target.value,
                        })
                      }
                      value={this.state.schizophrenia}
                    >
                      <Space direction="horizontal">
                        <Radio value={"Yes"}>Yes</Radio>
                        <Radio value={"No"}>No</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                </div>
              </div>
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  className="submit-button"
                  onClick={() => this.props.set_active_step(5)}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
